import {AggregateFunctionType} from "./types";
import FieldProto from "../../fields3/proto/field-proto";
import {AggregatorSum} from "./aggregator-sum";
import {Aggregator} from "./aggregator";

export function aggregatorFactory(type: AggregateFunctionType, field:FieldProto):Aggregator {


    switch (type) {
        case AggregateFunctionType.SUM:
        default:
            return new AggregatorSum(field)

    }


}